import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import ProductAudienceHeader from "../product_list/product_audience_header/product_audience_header";
import { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import {
  getAudiencePerformanceData,
  tokenverfy,
} from "../../sellers_module/services/seller/api";
import { captureGAEvent } from "../../sellers_module/shared/helper";


const headCells = [
  { id: "campaignName", label: "Campaign Name" },
  { id: "adName", label: "Ad Name" },
  { id: "audienceUsed", label: "Audience Used" },
  { id: "startDate", label: "Start Date" },
  { id: "adSpend", label: "Ad Spend ($)" },
  { id: "impression", label: "Impressions" },
  { id: "clicks", label: "Clicks" },
  { id: "ctr", label: "CTR (%)" },
  { id: "roas", label: "ROAS" },
  { id: "frequency", label: "Frequency" },
];
const AudienceDashboard = () => {
  const [data, setData] = useState([]);
  const [order, setOrder] = useState<"asc" | "desc" | undefined>("asc");
  const [orderBy, setOrderBy] = useState("campaignName");
  const [selectedValue, setSelectedValue] = useState<string>("");
  const [options, setOptions] = useState<any[]>([]);

  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);

    const sortedData = [...data].sort((a, b) => {
      if (isAscending) {
        return a[property] < b[property] ? -1 : 1;
      } else {
        return a[property] > b[property] ? -1 : 1;
      }
    });
    setData(sortedData);
  };
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };
  const [tableData, setTableData] = useState<any[]>([])
  const [aggregatedData, setAggregatedData] = useState<any>({})
  useEffect(() => {
    const getPerformance = async () => {
      try {
        // Get the ad_account_id from localStorage and remove 'act_' prefix
        const adAccountId = JSON.parse(localStorage.getItem("ad_account_id") || "[]")?.[0]?.replace(/^act_/, "");
        // Fetch performance data with the cleaned ad_account_id
        const performanceData = await getAudiencePerformanceData(adAccountId);
        if (performanceData?.data) {
            console.log("🚀 ~ getPerformance ~ performanceData:", performanceData);
            setTableData(transformCampaignData(performanceData?.data as any[]));
            setAggregatedData(calculateAggregates(performanceData?.data));
        }
      } catch (e) {
        console.log("🚀 ~ getPerformance ~ e:", e);
      }
    };

    getPerformance();
  }, []);
  useEffect(() => {
    getAccounts();
  }, [selectedValue]);
  const getAccounts = async () => {
    const storedToken = localStorage.getItem("satellizer_token");
    const data = {
      token: storedToken,
      validate_token_request: 1,
    };
    const response = await tokenverfy(data);
    console.log("Token verification response:", response.data);
    const result = response.data.result || [];
    const accountOptions = result.map((account) => {
      const cleanedAccountId = account.account_id.replace(/^act_/, "");
      const accountName = account.account_name || "Unknown Account";
      return {
        value: cleanedAccountId,
        label: `Account id - ${cleanedAccountId} (${accountName})`,
      };
    });
    setOptions(accountOptions);
    if (accountOptions.length > 0) {
      setSelectedValue(accountOptions?.[0]?.value);
    }
  };
  const handleAudienceIdChange = (event) => {
    captureGAEvent("click", "Audience_Purchase_Selected_AccountID");
    const newValue = event.target.value;
    setSelectedValue(newValue);
  };
  return (
    <Box>
      <ProductAudienceHeader />

      <Box
        sx={{
          mt: "120px",
          paddingLeft: "5%",
          paddingRight: "5%",
          fontFamily: "sfpromedium",
        }}
      >
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Stack
            direction={"column"}
            sx={{
              justifyContent: "space-between",
            }}
          >
            <a
              onClick={() => handleGoBack()}
              style={{
                padding: "0px",
                color: "blue",
                cursor: "pointer",
                fontSize: "11px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ArrowBackIcon
                style={{ marginRight: "8px", marginBottom: "2px" }}
                sx={{
                  fontSize: 11,
                }}
              />{" "}
              Go back
            </a>
            <Typography
              variant="h6"
              fontWeight={"bold"}
              sx={{
                mb: 3,
              }}
            >
              Audience Performance Dashboard
            </Typography>
          </Stack>

          <FormControl
            variant="outlined"
            size="small"
            style={{ minWidth: "350px", maxWidth: "350px" }}
          >
            <InputLabel id="audience-select-label">Account</InputLabel>
            <Select
              labelId="audience-select-label"
              value={selectedValue}
              onChange={handleAudienceIdChange}
              label="Account"
            >
              {/* If options are empty, show a default item */}
              {options.length === 0 ? (
                <MenuItem value="" disabled>
                  No Accounts Available
                </MenuItem>
              ) : (
                // Map through options to create dropdown items
                options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label} {/* Display formatted label */}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </Stack>
        <Stack
          direction={"row"}
          gap={2}
          sx={{
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          <ValueCard
            value={formatCurrency(aggregatedData?.totalSpends,2, "₹")}
            label={"Total Spends"}
            sx={{
              background:
                "linear-gradient(153deg, rgba(174,217,238,1) 0%, rgba(76,57,171,1) 100%)",
              color: "white",
            }}
          />
          <ValueCard
            value={aggregatedData?.avgROAS}
            label={"Avg. ROAS"}
            sx={{
              background:
                "linear-gradient(153deg, rgba(238,217,174,1) 0%, rgba(224,72,12,1) 100%)",
              color: "white",
            }}
          />
          <ValueCard
            value={aggregatedData?.avgCTR}
            label={"AVG. CTR"}
            sx={{
              background:
                "linear-gradient(153deg, rgba(173,232,189,1) 0%, rgba(3,83,13,1) 100%)",
              color: "white",
            }}
          />
          <ValueCard
            value={aggregatedData?.totalClicks}
            label={"Total Clicks"}
            sx={{
              background:
                "linear-gradient(153deg, rgba(176,169,208,1) 0%, rgba(15,3,83,1) 100%)",
              color: "white",
            }}
          />
        </Stack>

        <Box component={Paper}>
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 500,
              overflow: "auto",
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : "asc"}
                        onClick={() => handleSort(headCell.id)}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((row:any, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)", // Add a light hover effect
                        cursor: "pointer", // Change cursor to indicate interactivity
                      },
                    }}
                  >
                    <TableCell>{row?.campaignName}</TableCell>
                    <TableCell>{row?.adName}</TableCell>
                    <TableCell>{row?.audienceUsed}</TableCell>
                    <TableCell>{row?.startDate}</TableCell>
                    <TableCell>{formatCurrency(row?.adSpend, 2, "₹") || 0}</TableCell>
                    <TableCell>{row?.impression}</TableCell>
                    <TableCell>{row?.clicks}</TableCell>
                    <TableCell>{row?.ctr}</TableCell>
                    <TableCell>{row?.roas}</TableCell>
                    <TableCell>{row?.frequency}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default AudienceDashboard;

const ValueCard = (props: { label: string; value: string; sx?: any }) => {
  return (
    <Box
      component={Paper}
      sx={{
        p: 2,
        width: {
          lg: "24%",
          md: "49%",
          sm: "100%",
        },
        borderRadius: 5,
        ...props.sx,
      }}
    >
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Typography variant="h4" fontWeight={400}>
          {props.value  || 0}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={"bold"}
          color={"rgba(255,255,255,0.8)"}
        >
          {props.label}
        </Typography>
      </Stack>
    </Box>
  );
};
const formatCurrency = (value: any, decimals: any = 1, symbol: any = ""): string => {
  const num = Number(value);
  if (isNaN(num)) {
    return `${symbol}0.00`;
  }
  if (num >= 1_000_000_000) {
    return `${symbol}${(num / 1_000_000_000).toFixed(decimals)}B`;
  }
  if (num >= 1_000_000) {
    return `${symbol}${(num / 1_000_000).toFixed(decimals)}M`;
  }
  if (num >= 1_000) {
    return `${symbol}${(num / 1_000).toFixed(decimals)}k`;
  }
  return `${symbol}${num.toFixed(decimals)}`;
};

//   formatCurrency(1234567, 2, "$"); // Output: $1.23M
const transformCampaignData = (data: any[]) => {
    return data.flatMap((campaign) => 
      campaign.ads.map((ad: any) => ({
        campaignName: campaign.campaign_name, // Campaign name from the campaign object
        adName: ad.name, // Ad name from the ad object
        audienceUsed: ad.custom_audiences
          .map((audience: any) => audience.name)
          .join(", "), // Combine audience names into a single string
        startDate: ad.date_start, // Start date of the ad
        adSpend: parseFloat(ad.spend || "0").toFixed(2), // Convert spend to a float with 2 decimals
        impression: ad.impressions, // Impressions from the ad object
        clicks: ad.click || 0, // Handle missing click data (default to 0)
        ctr:
          ad.impressions && ad.click // Calculate CTR if impressions and clicks are valid
            ? (
                (parseFloat(ad.click || "0") / parseFloat(ad.impressions)) *
                100
              ).toFixed(2)
            : "0.00",
        roas:
          ad.purchase_roas.length > 0
            ? parseFloat(ad.purchase_roas[0].value).toFixed(2)
            : "0.00", // ROAS value (default to 0 if not available)
        frequency: parseFloat(ad.frequency || "0").toFixed(2), // Frequency from the ad object
      }))
    );
  };
  
  const calculateAggregates = (data: any[]) => {
    let totalSpends = 0;
    let totalROAS = 0;
    let totalCTR = 0;
    let totalClicks = 0;
    let totalAds = 0;
    let validCTRCount = 0;
  
    data.forEach((campaign) => {
      campaign.ads.forEach((ad: any) => {
        const spends = isNaN(Number(ad.spend)) ? 0 : Number(ad.spend);
        const roas = ad.purchase_roas?.[0]?.value
          ? isNaN(Number(ad.purchase_roas[0].value))
            ? 0
            : Number(ad.purchase_roas[0].value)
          : 0;
        const clicks = isNaN(Number(ad.click)) ? 0 : Number(ad.click);
        const impressions = isNaN(Number(ad.impressions)) ? 0 : Number(ad.impressions);
  
        totalSpends += spends;
        totalROAS += roas;
  
        if (impressions > 0) {
          totalCTR += (clicks / impressions) * 100;
          validCTRCount++;
        }
  
        totalClicks += clicks;
        totalAds++;
      });
    });
  
    const avgROAS = totalAds > 0 ? (totalROAS / totalAds).toFixed(2) : "0.00";
    const avgCTR = validCTRCount > 0 ? (totalCTR / validCTRCount).toFixed(2) : "0.00";
  
    return {
      totalSpends: totalSpends.toFixed(2),
      avgROAS,
      avgCTR,
      totalClicks,
    };
  };
